import PageHeadline from '../../components/molecules/headlines/PageHeadline.vue'
import DecorationSubTitle from '../../components/atoms/decoration/DecorationSubTitle.vue'
import DecorationSubTitleSmall from '../../components/atoms/decoration/DecorationSubTitleSmall.vue'

export default {
  components: { PageHeadline, DecorationSubTitle, DecorationSubTitleSmall }
}
